export default __webpack_public_path__ + "static/media/privilege-star.fe93bbf6.svg";